import {
  addCustomFinalInvoiceType,
  clearCustomFinalInvoiceType,
} from 'actions/Lots/uploadCustomFinalInvoice';

const INITIAL_STATE = {
  grgFinalInvoice: null,
};

const uploadCustomFinalInvoiceReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case addCustomFinalInvoiceType:
      return {
        grgFinalInvoice: action.payload.grgFinalInvoice,
      };
    case clearCustomFinalInvoiceType:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};

export { uploadCustomFinalInvoiceReducer };
